<template>
  <div class="header-nav-mobile">
    <b-nav class="d-flex align-items-center">
      <b-nav-item
        active
        href="/dashboard"
        class=""
      >
        Quản trị
      </b-nav-item>
      <b-nav-item v-b-modal.modalMenuMobile>
        <feather-icon
          icon="MoreHorizontalIcon"
          class="text-white"
          size="20"
        />
      </b-nav-item>
      <notification-dropdown class="notify-home" />

      <b-nav-item
        href="/tim-kiem"
        class="btn_search_home"
      >
        <feather-icon
          id="SearchIcon"
          icon="SearchIcon"
          class="SearchIcon p-0 "
          height="21px"
          width="21px"
        />
      </b-nav-item>
      <user-dropdown class="avatar-home bg-transparent">
        <template #dropdownItemFirst="{ userData }">
          <b-dropdown-header
            id="dropdown-header-label"
            class="text-primary text-center"
          >
            {{ userData ? userData.full_name : '' }}
          </b-dropdown-header>
          <b-dropdown-divider />
          <b-dropdown-item
            :to="{ name: 'home-bookmark' }"
            link-class="d-flex align-items-center"
          >
            <feather-icon
              size="16"
              icon="BookmarkIcon"
              class="mr-50"
            />
            <span>Tin đánh dấu</span>
          </b-dropdown-item>
          <b-dropdown-item
            :to="{ name: 'dashboard' }"
            link-class="d-flex align-items-center"
          >
            <feather-icon
              size="16"
              icon="TabletIcon"
              class="mr-50"
            />
            <span>{{ $t('Dashboard') }}</span>
          </b-dropdown-item>
        </template>
      </user-dropdown>
    </b-nav>

    <!-- modal Scrolling Content inside Modal-->
    <b-modal
      id="modalMenuMobile"
      ref="refModalMenuMobile"
      scrollable
      title="Tất cả các chuyên mục"
      :hide-footer="true"
      centered
    >
      <ul class="flex-wrap d-flex list-unstyled pl-1 row">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="col-6 col-md-4"
        >
          <a
            class="nav-link text-white d-flex font-category font-weight-700"
            @click="clickItemMenuMobile(item.url)"
          >
            <span class="text-dark-3 ">{{ item.title }}</span>
          </a>
          <ul
            class="nav"
            style="flex-direction: column;"
          >
            <li
              v-for="(child, childKey) in item.childs"
              :key="childKey"
              class="nav-item padding-nav-item padding-custom-r-5 padding-left0-1366"
              style=""
            >
              <a
                class="nav-link text-dark-3 d-flex font-category"
                style="padding-top: 2px; padding-bottom: 2px;"
                :title="child.title"
                @click="clickItemMenuMobile(child.url)"
              >
                <span class="text-dark-3 ">{{ child.title }}</span>
              </a>
            </li>
          </ul>
        </li>
        <li
          v-if="$can('files.indexDalet', 'Files')"
          class="col-6 col-md-4"
        >
          <a
            class="nav-link text-white d-flex font-category font-weight-700"
            title="Multimedia"
            @click="clickItemMenuMobile('/home/multimedia/dalet')"
          >
            <span class="text-dark-3 ">Multimedia</span>
          </a>
          <ul
            class="nav"
            style="flex-direction: column;"
          >
            <li class="nav-item padding-nav-item padding-custom-r-5 padding-left0-1366">
              <a
                class="nav-link text-dark-3 d-flex font-category"
                style="padding-top: 2px; padding-bottom: 2px;"
                title="Dalet"
                @click="clickItemMenuMobile('/home/multimedia/upload-dalet')"
              >Upload vào dalet</a>
            </li>
            <li class="nav-item padding-nav-item padding-custom-r-5 padding-left0-1366">
              <a
                class="nav-link text-dark-3 d-flex font-category"
                style="padding-top: 2px; padding-bottom: 2px;"
                title="Dalet"
                @click="clickItemMenuMobile('/home/multimedia/dalet')"
              >Đến cổng điện tử</a>
            </li>
            <li class="nav-item padding-nav-item padding-custom-r-5 padding-left0-1366 d-none">
              <a
                class="nav-link text-dark-3 d-flex font-category"
                style="padding-top: 2px; padding-bottom: 2px;"
                title="Dalet"
                @click="clickItemMenuMobile('/home/multimedia/editor-network')"
              >Đến mạng biên tập</a>
            </li>
            <li class="nav-item padding-nav-item padding-custom-r-5 padding-left0-1366 d-none">
              <a
                class="nav-link text-dark-3 d-flex font-category"
                style="padding-top: 2px; padding-bottom: 2px;"
                title="Dalet"
                @click="clickItemMenuMobile('/home/multimedia/vov5')"
              >VOV5</a>
            </li>
            <li class="nav-item padding-nav-item padding-custom-r-5 padding-left0-1366 d-none">
              <a
                class="nav-link text-dark-3 d-flex font-category"
                style="padding-top: 2px; padding-bottom: 2px;"
                title="Dalet"
                @click="clickItemMenuMobile('/home/multimedia/vovnews')"
              >VOVNEWS</a>
            </li>
          </ul>
        </li>
        <li class="col-6 col-md-4">
          <a
            class="nav-link text-white d-flex font-category font-weight-700"
            title="Tin mới"
            @click="clickItemMenuMobile('/home/tin-moi.html')"
          >
            <span class="text-dark-3 ">Tin mới</span>
          </a>
        </li>
      </ul>
    </b-modal>
  </div>
</template>
<script>
import {
  BDropdownItem, BDropdownHeader, BDropdownDivider, BButton, BModal, VBModal, BNav, BNavItem,
} from 'bootstrap-vue';
import NotificationDropdown from '@core/layouts/components/app-navbar/components/NotificationHomeDropdown.vue';
import UserDropdown from '@core/layouts/components/app-navbar/components/UserHomeDropdown.vue';
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BNav,
    BNavItem,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
    BButton,
    BModal,
    NotificationDropdown,
    UserDropdown,
  },
  // directives: {
  //   'click-outside': {
  //     bind(el, binding, vNode) {
  //       console.log(binding);
  //       // Provided expression must evaluate to a function.
  //       if (typeof binding.value !== 'function') {
  //         const compName = vNode.context.name
  //         let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
  //         if (compName) { warn += `Found in component '${compName}'` }

  //         console.warn(warn)
  //       }
  //       // Define Handler and cache it on the element
  //       const { bubble } = binding.modifiers
  //       const handler = (e) => {
  //         if (bubble || (!el.contains(e.target) && el !== e.target)) {
  //           binding.value(e)
  //         }
  //       }
  //       el.__vueClickOutside__ = handler

  //       // add Event Listeners
  //       document.addEventListener('click', handler)
  //     },

  //     unbind(el, binding) {
  //       // Remove Event Listeners
  //       document.removeEventListener('click', el.__vueClickOutside__)
  //       el.__vueClickOutside__ = null
  //     },
  //   },
  // },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
    }
  },

  methods: {
    closeDropDownMobile() {
      document.getElementById('myDropdownMobile').classList.remove('show');
      document.getElementById('myDropdownMobile').classList.toggle('hidden');
    },
    showDropDownMobile() {
      document.getElementById('myDropdownMobile').classList.remove('hidden');
      document.getElementById('myDropdownMobile').classList.toggle('show');
    },
    outside(e) {
      const container = document.getElementById('myDropdownMobile');
      if (container.classList.contains('show')) {
        document.getElementById('myDropdownMobile').classList.remove('show');
      }
      // document.getElementById('myDropdown').classList.remove('show');
    },
    inside(e) {
      // document.getElementById('myDropdownMobile').classList.remove('hidden');
      document.getElementById('myDropdownMobile').classList.toggle('show');
    },
    clickItemMenuMobile(url) {
      this.$bvModal.hide('modalMenuMobile');
      this.$router.push({ path: url })
    },
  },
}
</script>
<style lang="scss">
.dropbtn:hover,
.dropbtn:focus {
  background-color: #2980B9;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content-mobile {
  display: none;
  // position: absolute;
  background-color: #f1f1f1;
  // min-width: 160px;
  // overflow: auto;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  // z-index: 1;
  top: 0px;
  left: 0px;
  position: fixed;
  height: 100%;
  z-index: 9999
}

.dropdown-content-mobile a {
  color: black;
  padding: 12px 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  text-decoration: none;
  display: block;
}

.dropdown a:hover {
  background-color: #ddd;
}
</style>
